// This guard resolves auth then either allows the route or redirects to the internal
// /login route. It must never call loginWithRedirect: /login is the single funnel to
// Auth0 (the button in LoginView.onSignIn). No guard, interceptor, or watcher may
// auto-redirect to Auth0.
import type { RouteLocationNormalized, Router } from 'vue-router';
import { auth0 } from '@/plugins/auth0';
import { buildLoginRoute } from '@/common/session';
import { nextTick, watch } from 'vue';

const DEFAULT_TITLE = 'SoloRx';

const waitForAuthReady = (): Promise<void> => {
  if (!auth0.isLoading.value) return Promise.resolve();
  return new Promise((resolve) => {
    const stop = watch(auth0.isLoading, (loading) => {
      if (!loading) {
        stop();
        resolve();
      }
    });
  });
};

export function registerGuard(router: Router) {
  router.beforeEach(async (to: RouteLocationNormalized) => {
    if (!to.meta.requiresAuth) return true;

    await waitForAuthReady();
    if (auth0.isAuthenticated.value) return true;

    return buildLoginRoute(to.fullPath, '');
  });

  router.afterEach((to) => {
    // Use next tick to handle router history correctly
    nextTick(() => {
      document.title = (to.meta.title ? to.meta.title : to.name?.toString()) + ' - ' + DEFAULT_TITLE;
    });
  });
}
